import { ChefHat, PartyPopper, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { imgUrl } from "@/lib/api";

const CARDS = [
  {
    key: "bulk",
    icon: ChefHat,
    title: "Bulk Food",
    desc: "Party trays & tiffin-scale orders from our cloud kitchen. Perfect for offices, small functions and get-togethers.",
    img: "https://images.unsplash.com/photo-1555244162-803834f70033?crop=entropy&cs=srgb&fm=jpg&w=800&q=75",
    target: "#calculator",
    cta: "Calculate price",
  },
  {
    key: "catering",
    icon: PartyPopper,
    title: "Catering",
    desc: "Full-service event catering with live counters, servers and setup. Weddings, receptions and corporate events.",
    img: "https://images.pexels.com/photos/12688995/pexels-photo-12688995.jpeg?auto=compress&cs=tinysrgb&w=800",
    target: "#packages",
    cta: "View packages",
  },
];

export function Services({ images }) {
  const go = (t) => document.querySelector(t)?.scrollIntoView({ behavior: "smooth" });
  const cardImg = (c) => (images?.[`service_${c.key}`] ? imgUrl(images[`service_${c.key}`]) : c.img);
  return (
    <section id="services" className="px-5 py-16">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <Overline>What we do</Overline>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-primary mt-3">
            Two ways to feast
          </h2>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
          {CARDS.map((c, i) => (
            <Reveal key={c.key} delay={i * 0.1}>
              <button
                data-testid={`service-card-${c.key}`}
                onClick={() => go(c.target)}
                className="group w-full text-left rounded-3xl overflow-hidden border border-border bg-card active:scale-[0.99] transition-transform"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img src={cardImg(c)} alt={c.title} loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <span className="absolute top-4 left-4 grid place-items-center w-11 h-11 rounded-full bg-background/90 text-primary">
                    <c.icon className="w-5 h-5" />
                  </span>
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between">
                    <h3 className="font-serif text-3xl text-primary tracking-tight">{c.title}</h3>
                    <ArrowUpRight className="w-5 h-5 text-accent" />
                  </div>
                  <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{c.desc}</p>
                  <span className="mt-4 inline-block text-sm font-medium text-primary underline underline-offset-4">
                    {c.cta}
                  </span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
